/* eslint-disable react/no-array-index-key */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';

import {
	PieChart,
	Pie,
	Cell,
	Legend,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';
import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';

export function GraficoModalidade(props) {
	const { data, loading } = props;
	const [grafico, setGrafico] = useState([
		{
			name: '',
			value: 0,
		},
	]);
	const COLORS = [
		color.primary,
		color.secondary,
		color.gray,
		color.red,
		color.green,
		color.yellow,
	];

	useEffect(() => {
		const dataArray = [];
		const dataAux = [];

		// Revisar função gráfico Modalidade mais utilizada
		for (let i = 0; i < data.length; i += 1) {
			dataArray.push({
				name: data[i].modalidade,
				value: data[i].porcentagem,
			});
		}
		// Ordenação provisónia antes de acrescentar os novos elementos do gráfico (parcelamento)
		if (dataArray.length === 3) {
			dataAux.push(dataArray[2]);
			dataAux.push(dataArray[0]);
			dataAux.push(dataArray[1]);
		} else if (dataArray.length === 2) {
			dataAux.push(dataArray[0]);
			dataAux.push(dataArray[1]);
		} else if (dataArray.length === 1) {
			dataAux.push(dataArray[0]);
		}

		setGrafico(dataAux);
	}, [data]);

	if (loading) {
		return (
			<div
				className="d-flex align-items-center justify-content-center"
				style={{ height: '300px' }}>
				<LoaderMini width="70" />
			</div>
		);
	}

	if (!loading && grafico.length === 0) {
		return <Text>Sem resultados no periodo</Text>;
	}

	return (
		<div style={{ width: '100%', height: 300 }}>
			<ResponsiveContainer>
				<PieChart width={400} height={400}>
					<Pie
						data={grafico}
						dataKey="value"
						innerRadius={60}
						outerRadius={90}>
						{grafico.map((entry, index) => (
							<Cell
								key={`cell-${index}`}
								fill={COLORS[index % COLORS.length]}
							/>
						))}
					</Pie>
					<Tooltip formatter={(value) => `${value}%`} />
					<Legend />
				</PieChart>
			</ResponsiveContainer>
		</div>
	);
}

GraficoModalidade.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	data: PropTypes.arrayOf(PropTypes.any),
	loading: PropTypes.bool.isRequired,
};

GraficoModalidade.defaultProps = {
	data: [],
};
